import { render, staticRenderFns } from "./LipidsPage.vue?vue&type=template&id=673c6e90&scoped=true&"
import script from "./LipidsPage.vue?vue&type=script&lang=js&"
export * from "./LipidsPage.vue?vue&type=script&lang=js&"
import style0 from "./LipidsPage.vue?vue&type=style&index=0&id=673c6e90&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673c6e90",
  null
  
)

export default component.exports